module.exports = __webpack_public_path__ + "ab4ecefaad5c3124cf67c9097a25cbfb.svg";